import { Clock, XCircle } from "lucide-react";

export function VerifyBusiness({
  status,
  rejectionReason,
}: {
  status: string;
  rejectionReason?: string | null;
  onApproved?: () => void;
}) {
  const rejected = status === "REJECTED";

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4 py-10">
      <div className="w-full max-w-lg">
        <div className="bg-white rounded-xl shadow-sm border border-stone-200 p-8 text-center">
          <div
            className={`mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-5 ${
              rejected ? "bg-red-50" : "bg-amber-50"
            }`}
          >
            {rejected ? (
              <XCircle className="w-7 h-7 text-red-500" />
            ) : (
              <Clock className="w-7 h-7 text-amber-500" />
            )}
          </div>

          {rejected ? (
            <>
              <h1 className="text-2xl font-semibold text-stone-900 mb-2 font-display">
                Account not approved
              </h1>
              <p className="text-sm text-stone-500 leading-relaxed mb-5">
                We were unable to approve your account at this time.
              </p>
              {rejectionReason && (
                <div className="flex items-start gap-2 text-sm text-red-700 bg-red-50 border border-red-100 px-3 py-2.5 rounded-lg mb-5 text-left">
                  <XCircle className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>{rejectionReason}</span>
                </div>
              )}
              <p className="text-xs text-stone-400">
                If you think this is a mistake, reply to our email or contact our team.
              </p>
            </>
          ) : (
            <>
              <h1 className="text-2xl font-semibold text-stone-900 mb-2 font-display">
                Your account is under review
              </h1>
              <p className="text-sm text-stone-500 leading-relaxed">
                We're verifying your ACRA registration and business details. We'll call you shortly to complete setup — most accounts are activated within one business day.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
